import { Layers3 } from 'lucide-react';
import { useRecoilState, useRecoilValue } from 'recoil';
import DropdownToggleButton from '~/components/Buttons/DropdownToggleButton';
import { selectedOperationState } from '~/state/atoms/toolsAtoms';
import ClearTool from './ClearTool';
import KeepEveryNthSliceTool from './KeepEveryNthSliceTool';
import { ClickAwayListener, Divider, Stack } from '@mui/material';
import InterpolationOperation from './InterpolationOperation';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';

function SliceClearingOperationLayout({
    onClickAway,
}: {
    onClickAway: () => void;
}) {
    return (
        <ClickAwayListener onClickAway={onClickAway}>
            <Stack p={3} gap={2}>
                <ClearTool />
                <KeepEveryNthSliceTool />
                <Divider flexItem orientation="horizontal" sx={{ my: 1 }} />
                <InterpolationOperation />
            </Stack>
        </ClickAwayListener>
    );
}

export function SliceClearingOperation() {
    const [operation, setOperation] = useRecoilState(selectedOperationState);
    const selectedStructureSet = useRecoilValue(currentStructureSetState);
    const isDisabled =
        !selectedStructureSet || selectedStructureSet.roiArray.length === 0;

    const handleClickAway = () => {
        setOperation(null);
    };

    return (
        <DropdownToggleButton
            isSelected={operation === 'edit-slice'}
            value="edit-slice"
            onToggle={() =>
                setOperation(operation === 'edit-slice' ? null : 'edit-slice')
            }
            icon={<Layers3 />}
            tooltipTitle="Automatic slice editing"
            popperComponent={
                operation === 'edit-slice' ? (
                    <SliceClearingOperationLayout
                        onClickAway={handleClickAway}
                    />
                ) : (
                    <></>
                )
            }
            disabled={isDisabled}
        />
    );
}
